import { Input } from '@avanta/shared/components/ui/Input';
import {
  createConfirmPasswordValidator,
  validationsPassword,
  validationsRequired,
} from '@avanta/shared/constants/validations';
import { type InputForm } from 'types/form';

export interface ChangePasswordFormData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const changePasswordForm: Record<string, InputForm> = {
  currentPassword: {
    label: 'ChangePassword.Form.currentPassword.label',
    name: 'currentPassword',
    placeholder: 'ChangePassword.Form.currentPassword.placeholder',
    type: 'password',
    required: true,
    autocomplete: 'current-password',
    rules: {
      ...validationsRequired,
    },
    component: Input,
  },
  newPassword: {
    label: 'ChangePassword.Form.newPassword.label',
    name: 'newPassword',
    placeholder: 'ChangePassword.Form.newPassword.placeholder',
    type: 'password',
    required: true,
    autocomplete: 'new-password',
    rules: validationsPassword,
    component: Input,
  },
  confirmPassword: {
    label: 'ChangePassword.Form.confirmPassword.label',
    name: 'confirmPassword',
    placeholder: 'ChangePassword.Form.confirmPassword.placeholder',
    type: 'password',
    required: true,
    autocomplete: 'new-password',
    rules: {
      ...validationsRequired,
    },
    validate: createConfirmPasswordValidator('newPassword', 'ChangePassword.error.mismatch'),
    component: Input,
  },
};
